interface GradientCardProps {
  Icon: React.ElementType | string; // Can be either an icon component or image URL string
  className?: string;
  onClick?: () => void;
  count?: number; // optional badge count
}

export default function IconCard({ Icon, className, onClick, count }: GradientCardProps) {
  return (
    <div className={`relative transition-all duration-300 hover:scale-110 ${className}`}>
      <div
        className="flex items-center justify-center w-full h-full bg-transparent rounded-md transition-all duration-300 hover:bg-opacity-90"
        onClick={onClick}
      >
        {typeof Icon === 'string' ? (
          // If Icon is a string (image URL), render as image
          <img
            src={Icon}
            alt="User profile"
            className="w-7 h-7 rounded-full object-cover mt-1"
          />
        ) : (
          // If Icon is a component (SVG icon), render as icon
          <Icon
            size={20}
            className="text-black dark:text-white transition-colors duration-300 hover:text-themeGreen dark:hover:text-[#d7a407]"
          />
        )}

        {count && count > 0 && (
          <span className="absolute -top-1 -right-1 text-[10px] bg-red-500 text-white rounded-full px-1.5 py-0.5 leading-none">
            {count > 9 ? '9+' : count}
          </span>
        )}
      </div>
    </div>
  );
}